import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyBusinessPrioritiesChanges } from '../../api'
import { mapBusinessPriorityToApi } from '../../lib'
import { IBusinessPriority } from '../types'

export const requestBusinessPrioritiesDelete = createAsyncThunk(
  'businessPriorities/delete',
  async (record: IBusinessPriority, { getState }) => {
    const fYear = selectJBPSettingsCurrentFYear(getState())
    const payload = mapBusinessPriorityToApi(record, fYear)

    await applyBusinessPrioritiesChanges({
      ...payload,
      Status: 'Deleted',
    })

    return record
  }
)
